import LDClientSingleton from './ldClientSingleton';

export const getFlagValue = (flagKey: string) => {
  const ldClient = LDClientSingleton.getInstance();
  if (!ldClient) {
    throw new Error('LD Client is not initialized');
  }
  return ldClient.variation(flagKey, false);
};
